// `React` in scope for the classic-runtime renderchecks — see `CrossIcon`.
import React from "react";
import { Lock } from "@rista/ui/library/icons/glyphs";

// The drawing is the design system's icon glyph (`@rista/ui/library/icons/glyphs`, DESIGN_SYSTEM.md QD10); this keeps
// this file's import path and the size and colour it always drew, so its callers render exactly as before.
export function LockIcon({ color = "#111C36" }: { color?: string }) {
  return <Lock size={12} color={color} />;
}

LockIcon.displayName = "LockIcon";
export default LockIcon;
